// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-loader-docs',
    templateUrl: './loader.docs.generated.html',
})
export class UILoaderDocs { }
